import ROLES from "constants/user";
import useIsRoles from "hooks/useIsRoles";

const PROSPECTING_ROLES = [ROLES.PROSPECTING];

export default function useIsProspectingRole() {
  return useIsRoles(PROSPECTING_ROLES);
}
